import React, { useState } from 'react';
import { Card, CardContent, Typography, Grid, Box, IconButton } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';

// פונקציה לסיכום הקברים לפי סטטוס
const getGraveStats = (items) => {
  const stats = { free: 0, purchase: 0, reserve: 0, burial: 0 };
  items.forEach(grave => {
    stats[grave.graveStatus] = (stats[grave.graveStatus] || 0) + 1;
  });
  stats.total = items.length;
  return stats;
};

// קומפוננטת הכארד לכל בית עלמין
const CemeteryCard = ({ cemetery, blocks, plots, areaGraves, graves }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const filteredBlocks = blocks.filter(block => block.cemeteryId === cemetery?.unicId);

  return (
    <Card style={{ marginBottom: '20px', width: '100%' }}>
      <CardContent>
        <Grid container justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #ddd', pb: 1 }}>
          <Typography variant="h6">בית עלמין {cemetery.name}</Typography>
          <IconButton onClick={() => setIsExpanded(!isExpanded)}>
            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </Grid>

        {isExpanded && (
          <Box mt={2}>
            {filteredBlocks.map(block => (
              <BlockCard
                key={block?.unicId}
                block={block}
                plots={plots.filter(plot => plot.blockId === block?.unicId)}
                areaGraves={areaGraves}
                graves={graves}
              />
            ))}
          </Box>
        )}
      </CardContent>
    </Card>
  );
};

// קומפוננטת הכארד לכל גוש
const BlockCard = ({ block, plots, areaGraves, graves }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // סינון הקברים הרלוונטיים לגוש דרך החלקות והאחוזות
  const blockAreaGraves = areaGraves.filter(areaGrave => plots.some(plot => plot?.unicId === areaGrave.plotId));
  const blockGraves = graves.filter(grave => blockAreaGraves.some(areaGrave => areaGrave?.unicId === grave.areaGraveId));
  const blockStats = getGraveStats(blockGraves);

  return (
    <Box sx={{ pl: 4, mt: 2, backgroundColor: '#f7f7f7', borderLeft: '4px solid #ccc', mb: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center" sx={{ borderBottom: '1px solid #ddd', pb: 1 }}>
        <Typography variant="subtitle1">גוש: {block.name}</Typography>
        <Typography variant="subtitle1">
          פנויים {blockStats.free}, רכישות {blockStats.purchase}, שמורים {blockStats.reserve}, קבורים {blockStats.burial}, סה״כ {blockStats.total}
        </Typography>
        <IconButton onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Grid>

      {isExpanded && (
        <Box mt={2}>
          {plots.map(plot => (
            <PlotCard
              key={plot?.unicId}
              plot={plot}
              areaGraves={blockAreaGraves.filter(areaGrave => areaGrave.plotId === plot?.unicId)}
              graves={graves}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

// קומפוננטת הכארד לכל חלקה
const PlotCard = ({ plot, areaGraves, graves }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const plotGraves = graves.filter(grave => areaGraves.some(areaGrave => areaGrave?.unicId === grave.areaGraveId));
  const plotStats = getGraveStats(plotGraves);

  return (
    <Box sx={{ pl: 6, mt: 1, backgroundColor: '#eef2f7', borderLeft: '4px solid #bbb', mb: 1 }}>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="body1">חלקה: {plot.name}</Typography>
        <Typography variant="body1">
          פנויים {plotStats.free}, רכישות {plotStats.purchase}, שמורים {plotStats.reserve}, קבורים {plotStats.burial}, סה״כ {plotStats.total}
        </Typography>
        <IconButton onClick={() => setIsExpanded(!isExpanded)}>
          {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </IconButton>
      </Grid>

      {isExpanded && (
        <Box mt={1}>
          {areaGraves.map(areaGrave => (
            <AreaGraveCard
              key={areaGrave?.unicId}
              areaGrave={areaGrave}
              graves={graves.filter(grave => grave.areaGraveId === areaGrave?.unicId)}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

// קומפוננטת לכל אחוזת קבר
const AreaGraveCard = ({ areaGrave, graves }) => {
  return (
    <Box sx={{ pl: 8, mt: 1, backgroundColor: '#e0e7ff', borderLeft: '4px solid #888', mb: 1 }}>
      <Typography variant="body2">אחוזת קבר: {areaGrave.name}</Typography>
      <Box mt={1}>
        {graves.map(grave => (
          <Box key={grave?.unicId} sx={{ pl: 2, mb: 1 }}>
            <Grid container justifyContent="space-between" alignItems="center">
              <Typography variant="body2">{grave.name}</Typography>
              <Typography variant="body2">{grave.graveStatus}</Typography>
            </Grid>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

const GraveDetailTable = ({ cemeteries, blocks, plots, areaGraves, graves }) => {
  return (
    <div>
      {cemeteries.map(cemetery => (
        <CemeteryCard
          key={cemetery?.unicId}
          cemetery={cemetery}
          blocks={blocks}
          plots={plots}
          areaGraves={areaGraves}
          graves={graves}
        />
      ))}
    </div>
  );
};

export default GraveDetailTable;
